import { useEffect, useState } from "react";
import Typewriter from 'typewriter-effect';
import Header from "../components/header";
import InteractionModel, { InteractionAuthor } from "../data/InteractionModel";
import { SignupModelHelper } from "../data/SignupModel";
import { DeficiencyDto } from '../data/dto/deficiency.dto';
import AmarelinhoService from '../services/AmarelinhoService';
import { AmplitudeService } from '../services/AmplitudeService';

export default function Deficiencia(props: any) {

  const [deficiencyOptions, setDeficiencyOptions] = useState<DeficiencyDto[]>([]);

  const [typed, setTyped] = useState(false);
  const [interactions, setInteractions] = useState<InteractionModel[]>([]);

  useEffect(() => {
    SignupModelHelper.checkLogin().then(async (userId) => {
      if (!userId) {
        document.location = '#/';
      } else {
        AmarelinhoService.listDeficiencies().then(deficiencyList => {
          if (deficiencyList) {
            setDeficiencyOptions(deficiencyList);
            setTyped(true);
          } else {
            setTimeout(() => {
              setInteractions([...interactions, {
                text: 'Estou com problemas para buscar as opções de pretensão salarial. Favor tente mais tarde.',
                author: InteractionAuthor.AMARELINHO
              }])
              setTyped(false);
            }, 1000);
          }
        })
      }
    });



    // TagManager.dataLayer(dataLayerHelper.pagina('deficiencia', 'curriculo'));
    AmplitudeService.track('PCD Screen')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function updateDeficiencyExpectation(id: number) {
    const deficiency = id === 0 ? undefined : deficiencyOptions.find((se) => se.id === id);
    SignupModelHelper.update({ deficiency });
    AmplitudeService.track('PCD Submit', { pcd_type: deficiency?.name })
    document.location = '#/estado-civil';
  }

  return (
    <>
      <Header step={ 1 } total={ 3 } title="Sua Deficiência" previous="#/finalizado"></Header>
      <div className="chat-container">
        <div className="chat">
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">

                <div className="chat-item">
                  <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                  <div className="chat-item-content">
                    <Typewriter
                      onInit={ (typewriter) => {
                        typewriter
                          .changeDelay(15)
                          .typeString(`Precisamos falar sobre mais alguns dados pessoais.<br /><br />Você tem alguma deficiência?<br><br>Se sim, selecione uma das opções de deficiências, se não tiver, selecione a opção <strong>Não possuo</strong>.`)
                          .callFunction(() => {
                          })
                          .start();
                      } }
                    />
                  </div>
                </div>

                {
                  interactions.map((interaction) => {
                    let objRet;

                    if (interaction.author === InteractionAuthor.AMARELINHO) {
                      objRet = <div className="chat-item" key={ interactions.indexOf(interaction) }>
                        <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                        <div className="chat-item-content">
                          <Typewriter
                            onInit={ (typewriter) => {
                              typewriter.changeDelay(15).typeString(interaction.text)
                                .start();
                            } } />
                        </div>
                      </div>

                    } else if (interaction.author === InteractionAuthor.CLIENTE) {
                      objRet = <div className="chat-item chat-item-user" key={ interactions.indexOf(interaction) }>
                        <img src="images/ico-chat-user.svg" alt="Usuário" />
                        <div className="chat-item-content">
                          <p>{ interaction.text }</p>
                        </div>
                      </div>
                    }

                    return objRet;
                  })
                }
              </div>
            </div>
          </div>
        </div>

        { typed &&
          <footer className="footer-answer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="footer-answer-holder d-flex align-items-center justify-content-between">
                    <select name="" className="select select-hidden" id="deficiency" onChange={ (e) => updateDeficiencyExpectation(+e.target.value) } >
                      <option>Escolha uma opção</option>
                      <option value={ 0 }>Não possuo</option>
                      {
                        deficiencyOptions.map(deficiencyOption => (
                          <option key={ deficiencyOption.id } value={ deficiencyOption.id }>{ deficiencyOption.name }</option>
                        ))
                      }
                    </select>
                    <input type="text" name="" id="input" placeholder="Escolha uma opção" />
                    <button className="btn-submit" disabled >
                      <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0114286 20L24 10L0.0114286 0L0 7.77778L17.1429 10L0 12.2222L0.0114286 20Z"></path></svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        }
      </div>
    </>
  );
}

